import { render, staticRenderFns } from "./caution.vue?vue&type=template&id=6dd9acf9&scoped=true"
import script from "./caution.vue?vue&type=script&lang=js"
export * from "./caution.vue?vue&type=script&lang=js"
import style0 from "./caution.vue?vue&type=style&index=0&id=6dd9acf9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9acf9",
  null
  
)

export default component.exports